export default defineNuxtRouteMiddleware((to) => {
    const nuxt = useNuxtApp()
    if (to?.fullPath === nuxt.$localePath('/')) {
        return navigateTo(nuxt.$localePath('/about'));
    }
});
